import React, { useEffect, lazy, Suspense } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import useScrollToTop from '../../hooks/useScrollToTop';
import { initializeTracking } from '../../services/trackingService';
import { useUtm } from '../../hooks/useUtm';
import ClientOnly from '../ui/ClientOnly';

const ChatWidget = lazy(() => import('../chat/ChatWidget'));
const CookieConsentBanner = lazy(() => import('../marketing/CookieConsentBanner'));

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  useScrollToTop();
  useUtm(); // Initialize UTM parameter listener on every page load.

  useEffect(() => {
    // CRITICAL FIX: Guard all browser-specific APIs to prevent crashes during server-side prerendering.
    if (typeof window !== 'undefined') {
      // Check for existing consent on initial load.
      const consent = document.cookie.split('; ').find(row => row.startsWith('cookie_consent='));
      if (consent && consent.split('=')[1] === 'granted') {
        initializeTracking();
      }
    }
  }, []);

  const handleConsent = () => {
    initializeTracking();
  };

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
      <ClientOnly>
        <Suspense fallback={null}>
          <ChatWidget />
          <CookieConsentBanner onAccept={handleConsent} />
        </Suspense>
      </ClientOnly>
    </div>
  );
};

export default Layout;